// extracted by mini-css-extract-plugin
export default {"fullHeight":"zJL2boVb4hjqPTxJRfdD","tab":"TOikAU7sWo7QL2c2xT68"};